import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumberDisplay from '../../../../../components/number-display';

class SurveyOutreachAttemptRenderer extends Component {
  renderContent() {
    const { value, data } = this.props;
    const total = data.max_attempts !== undefined && data.max_attempts !== null ? data.max_attempts : data.total_attempts;
    if (total === 0 || !total) {
      return null;
    }
    const c = (<strong><NumberDisplay value={value} precision={0} /></strong>);
    const t = (<strong><NumberDisplay value={total} precision={0} suffix="attempt" suffixIsUnit /></strong>);
    return (
      <span>
        {c} <em>of</em> {t}
      </span>
    );
  }
  render() {
    const isGrouped = this.props.node && this.props.node.group;
    if (!isGrouped) {
      return this.renderContent();
    }
    return null;
  }
}

SurveyOutreachAttemptRenderer.propTypes = {
  value: PropTypes.number,
  data: PropTypes.shape({
    total_attempts: PropTypes.number,
    max_attempts: PropTypes.number,
  }),
  node: PropTypes.shape({
    group: PropTypes.bool,
  }),
};
SurveyOutreachAttemptRenderer.defaultProps = {
  value: null,
  data: {
    total_attempts: 0,
    max_attempts: null,
  },
  node: null,
};

export default SurveyOutreachAttemptRenderer;
